class BESSAppProjectCreditScore extends BESSAppBase {

    constructor(parent) {
        super();
        this.node = parent.node.find('.app-credit-score');
        this.score = this.node.find('.score-display');
    }

    update(score, scoped_out, score_rating) {
        if (this.node.length === 0) return;
        this.score.html(scoped_out ? "Scoped Out" : score + "%");
        let classList = this.node.attr("class");
        let classArr = classList.split(/\s+/);

        _.each(classArr, function (value) {
            if (value.startsWith('app-score-')) {

                this.node.removeClass(value);

            }
        }.bind(this));
        this.node.addClass(score_rating);
    }
}